module.exports = __webpack_public_path__ + "static/logo-063f46378cad6d4b58f46ae180a91a57.png";